import { render } from "./Widgets.vue?vue&type=template&id=15f2c614"
import script from "./Widgets.vue?vue&type=script&lang=js"
export * from "./Widgets.vue?vue&type=script&lang=js"

import "./Widgets.vue?vue&type=style&index=0&id=15f2c614&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__